
import Card from '../CardNFT';

import backgroundElipses from '../../assets/images/backgroundelipses.png'
import { cardsData } from '../../assets/constants/cardsdata';
import {GridCards,LeftSide,MainWrapper,SectionTitle,SubtitleText} from './styles'



const Collections = () => {
    return (
        <MainWrapper style={{
            backgroundImage: `url(${backgroundElipses})`,
            backgroundRepeat: 'space',
        }}>
            <LeftSide>
                <SectionTitle>Collections</SectionTitle>
                <SubtitleText>
                    With more than 180+ hand drawn traits, each NFT is unique and comes with a membership to an exclusive <br/> group  of successful investors. Join an ambitious ever-growing community with multiple benefits and utilities.
                </SubtitleText>
            </LeftSide>
            <GridCards>
            {cardsData.map(item => <Card item={item}/>)}
            </GridCards>

        </MainWrapper>
    )
};

export default Collections;